import React, { useState, useEffect } from "react";
import { Modal, Form, Input, Select, message } from "antd";
import { changePaymentDetails } from "../api/payments/paymentRequest";
import { getPaymentMethodInFrench } from "../utils/payment";

const { Option } = Select;
const { TextArea } = Input;

const EditPaymentModal = ({ 
  visible, 
  onCancel, 
  onSuccess, 
  payment 
}) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (visible && payment) {
      form.setFieldsValue({
        payment_method: payment.payment_method,
        reference_number: payment.reference_number,
        reason: ""
      });
    }
  }, [visible, payment, form]);

  const handleSubmit = async (values) => {
    setLoading(true);
    try {
      const response = await changePaymentDetails(payment.id, values);
      
      if (response.success) {
        message.success(response.message || "Détails du paiement mis à jour avec succès");
        form.resetFields();
        onSuccess();
      } else {
        message.error(response.error || "Erreur lors de la mise à jour");
      }
    } catch (error) {
      const errorMessage = error.response?.data?.error || "Erreur lors de la mise à jour des détails du paiement";
      message.error(errorMessage);
    } finally {
      setLoading(false);
    }
  };

  const handleCancel = () => {
    form.resetFields();
    onCancel();
  };

  const paymentMethods = [
    { value: "cash", label: "Espèces" },
    { value: "card", label: "Carte bancaire" },
    { value: "cheque", label: "Chèque" },
    { value: "bank_transfer", label: "Virement bancaire" },

  ];

  return (
    <Modal
      title="Modifier les détails du paiement"
      open={visible}
      onCancel={handleCancel}
      onOk={() => form.submit()}
      confirmLoading={loading}
      okText="Enregistrer"
      cancelText="Annuler"
      width={600}
    >
      <Form
        form={form}
        layout="vertical"
        onFinish={handleSubmit}
        initialValues={{
          payment_method: "",
          reference_number: "",
          reason: ""
        }}
      >
        <Form.Item
          label="Méthode de paiement"
          name="payment_method"
          rules={[
            { max: 255, message: "La méthode de paiement ne peut pas dépasser 255 caractères" }
          ]}
        >
          <Select placeholder="Sélectionner une méthode de paiement" allowClear>
            {paymentMethods.map(method => (
              <Option key={method.value} value={method.value}>
                {method.label}
              </Option>
            ))}
          </Select>
        </Form.Item>

        <Form.Item
          label="Numéro de référence"
          name="reference_number"
          rules={[
            { max: 255, message: "Le numéro de référence ne peut pas dépasser 255 caractères" }
          ]}
        >
          <Input placeholder="Entrer le numéro de référence" />
        </Form.Item>

        <Form.Item
          label="Raison de la modification"
          name="reason"
          rules={[
            { max: 1000, message: "La raison ne peut pas dépasser 1000 caractères" }
          ]}
        >
          <TextArea 
            rows={4} 
            placeholder="Expliquer la raison de cette modification..."
          />
        </Form.Item>
      </Form>

      {payment && (
        <div style={{ marginTop: 16, padding: 12, backgroundColor: "#f5f5f5", borderRadius: 4 }}>
          <strong>Informations actuelles :</strong>
          <div>Référence paiement: {payment.reference}</div>
          <div>Méthode: {getPaymentMethodInFrench(payment.payment_method)}</div>
          <div>Numéro de référence: {payment.reference_number || "N/A"}</div>
          <div>Montant: {payment.amount}</div>
        </div>
      )}
    </Modal>
  );
};

export default EditPaymentModal;